
<fieldset class="q-fieldset mb-3">
  <legend *ngIf="service.EffectifModel.DataListSelect && service.EffectifModel.DataListSelect.length > 0" (click)="OpenCG(ModalCustomGrid)" [ngClass]="{'CustomGridAvailable' : !utilities.isEmptyStr(service.EffectifModel.GridFileName)}" #legend> 
    <i class="{{service.Options.Icon}}"></i>{{service.Options.Title}} - {{service.EffectifModel.NombreEffectif}}<i class="fas fa-edit ml-2" *ngIf="!utilities.isEmptyStr(service.EffectifModel.GridFileName)"></i>
  </legend>
  <legend *ngIf="service.EffectifModel.DataListSelect && service.EffectifModel.DataListSelect?.length == 0" (click)="OpenCG(ModalCustomGrid)" #legend>
    <i class="{{service.Options.Icon}}"></i>{{service.Options.Title}}<i class="fas fa-edit ml-2" *ngIf="!utilities.isEmptyStr(service.EffectifModel.GridFileName)"></i>
  </legend>
  <div #header>
    <div class="d-flex mb-3">
      <button class="selected-element-container q-pointer" id="{{service.Options.Title}}" *ngIf="service.Options.Add" (click)="showManager($event)">
        <i class="fas fa-user-plus fa-flip-horizontal"></i>

        <div *ngIf="service?.EffectifModel?.DataListSelect?.length > 0" class="number-circle">
          {{service?.EffectifModel?.DataListSelect?.length}}
        </div>
        <div class="triangle-gauche" *ngIf="ShowManagerPopOver && screenSize > 450">
        </div>
        <div class="triangle-gauche-transparent" *ngIf="ShowManagerPopOver && screenSize > 450">
        </div>
      </button>

      <ng-container *ngIf="service.Options.Add || service.EffectifModel.DataListSelect?.length > 0 || service.EffectifModel.DataListFilter?.length > 0">
        <select class="ml-4 col q-main-select" *ngIf="service.EffectifModel.DataListFilter" (change)="selectFilter($event.target.value)">
          <option value="" *ngIf="service?.EffectifModel?.DataListFilter?.length > 1">- - - - - -</option>
          <option *ngFor="let Filter of service.EffectifModel.DataListFilter" value="{{Filter.Id}}">{{Filter.Text}}</option>
        </select>
      </ng-container>
    </div>

    <div *ngIf="ShowManagerPopOver" [ngClass]="screenSize > 450 ? 'PopOverManager' : 'PopOverManagerTablet'">
      <div *ngIf="screenSize <= 450" class="d-flex justify-content-between" [ngClass]="{'mb-3' : screenSize <= 450}">
        <p class="mb-0 q-c-main managerTitle">Gestion des {{service.Options.Title}}</p>
        <button type="button" class="close" aria-label="Close" (click)="showManager($event)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <effectifs-manager *ngIf="service.Options.Add " (click)="stopPropagation($event)"></effectifs-manager>
    </div>
    <ng-container *ngIf="service.Options.Add || service?.EffectifModel?.DataListSelect?.length > 0">
      <div   class="q-check q-render mt-3" *ngIf="service.Options.SelectionMode == SelectionMode.MULTIPLE">
        <input type="checkbox" id="{{service.Options.Title}}-{{service.Options.IdInstances}}"
               [indeterminate]="indeterminate"
               (change)="OnSelectAll();"
                [(ngModel)]="AllAreSelected" />
        <label for="{{service.Options.Title}}-{{service.Options.IdInstances}}">
          <span></span>Tout sélectionner
        </label>
      </div>
    </ng-container>
  </div>
  <div class="q-render flex-grow-1">
    <effectifs-render class="h-100"
                      [displayList]="show"
                      [Mode]="CRUD.UPDATE"
                      [List]="service.EffectifModel.DataListSelect"
                      (EventEffectif)="SingleEmit($event)"
                      [Template]="layoutTemplate">
    </effectifs-render>
  </div>
</fieldset>

<ng-template #ModalCustomGrid class="modal-dialog-centered" let-modal>
  <div class="p-4">
    <button type="button" class="close d-flex justify-content-end" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
    {{service.Options.Title}}
    <!--<button type="button" (click)="saveInfoCG()" class="btn btn-save ml-2"><i class="far fa-save"></i><span>Enregistrer</span></button>-->
    <q-customgrid [customgridName]="service.Options.GridName" [idDonnee]="stageService.Stage.Ident" (cellValueChanged)="saveInfoLienCG($event)"></q-customgrid>
  </div>
</ng-template>
